import React, {useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Text, Button, Flex, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../../html-sanitizer'

const Suggestions = ({suggestions, closeAndNavigate, onSuggestedCategorySubmit}) => {
    const styles = useMultiStyleConfig('Search', {variant: 'modalSearch'})

    const [focusedIdx, setFocusedIdx] = useState(-1)
    const buttonsRef = useRef([])

    const handleKeyDown = (e) => {
        if (!suggestions || suggestions.length === 0) return
        if (e.key === 'ArrowDown') {
            e.preventDefault()
            setFocusedIdx((prev) => {
                const next = prev < suggestions.length - 1 ? prev + 1 : 0
                buttonsRef.current[next]?.focus()
                return next
            })
        } else if (e.key === 'ArrowUp') {
            e.preventDefault()
            setFocusedIdx((prev) => {
                const next = prev > 0 ? prev - 1 : suggestions.length - 1
                buttonsRef.current[next]?.focus()
                return next
            })
        } else if (e.key === 'Enter' && focusedIdx >= 0) {
            e.preventDefault()
            const suggestion = suggestions[focusedIdx]
            if (suggestion) {
                localStorage.setItem('fromISP', true)
                suggestion.type === 'category'
                    ? onSuggestedCategorySubmit(e, suggestion.name)
                    : closeAndNavigate(suggestion)
            }
        }
    }

    if (!suggestions || suggestions?.length === 0) {
        return null
    }

    return (
        <Flex
            {...styles.suggestionsContainer}
            data-testid="suggestions-container"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            role="listbox"
        >
            {suggestions.map((suggestion, idx) =>
                suggestion ? (
                    <Button
                        ref={(el) => (buttonsRef.current[idx] = el)}
                        width="full"
                        onMouseDown={(e) => {
                            localStorage.setItem('fromISP', true)
                            suggestion.type === 'category'
                                ? onSuggestedCategorySubmit(e, suggestion.name)
                                : closeAndNavigate(suggestion)
                        }}
                        fontSize="md"
                        key={idx}
                        marginTop={0}
                        variant="menu-link"
                        {...styles.suggestionButton}
                        tabIndex={-1}
                        id={`suggestion-${idx}`}
                        role="option"
                        aria-selected={focusedIdx === idx}
                        _focusVisible={{boxShadow: 'outline'}}
                    >
                        <SanitizedHtml
                            as={Text}
                            fontWeight="normal"
                            {...styles.suggestionText}
                            html={
                                suggestion?.representedProduct?.c_variantIdentifier ||
                                suggestion?.productName ||
                                suggestion?.name
                            }
                            sanitize={true}
                        />
                    </Button>
                ) : null,
            )}
        </Flex>
    )
}

Suggestions.propTypes = {
    suggestions: PropTypes.array,
    closeAndNavigate: PropTypes.func,
    onSuggestedCategorySubmit: PropTypes.func,
}

export default Suggestions
